import { render } from "./CompetencyAssessment.vue?vue&type=template&id=f6dba306"
import script from "./CompetencyAssessment.vue?vue&type=script&lang=js"
export * from "./CompetencyAssessment.vue?vue&type=script&lang=js"

import "./CompetencyAssessment.vue?vue&type=style&index=0&id=f6dba306&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__